<template>
  <b-row>
    <b-col cols="12">
      <div>
        <p>Popovers are generally used to display additional information about any element when a user hovers over an element. The popover component accepts a component prop, which enables users to customize the look and feel of the popover area.</p>
      </div>
      <popover-position />
      <popover-variant />
      <popover-trigger />
      <popover-option />
      <!-- <popover-method /> -->
      <popover-event />
      <popover-advance />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PopoverPosition from './PopoverPosition.vue'
import PopoverTrigger from './PopoverTrigger.vue'
import PopoverOption from './PopoverOption.vue'
// import PopoverMethod from './PopoverMethod.vue'
import PopoverEvent from './PopoverEvent.vue'
import PopoverVariant from './PopoverVariant.vue'
import PopoverAdvance from './PopoverAdvance.vue'

export default {
  components: {
    BRow,
    BCol,

    PopoverPosition,
    PopoverTrigger,
    PopoverOption,
    // PopoverMethod,
    PopoverEvent,
    PopoverVariant,
    PopoverAdvance,
  },
}
</script>
